import { postRequest } from 'services/requests';

const services = {
    signIn: (body) => postRequest('/auth/sign-in', body),
    signUp: (body) => postRequest('/auth/sign-up', body),
    selectAccount: (body) => postRequest(`/auth/select-account`, body),
    unselectAccount: () => postRequest(`/auth/unselect-account`),
    logout: () => postRequest(`/auth/logout`),
    forgotPassword: (body) => postRequest(`/auth/forgot-password`, body),
};

export default services;
